<template>
  <div :class="$style['news-page-web']">
    <div :class="$style['header']">
      <div :class="$style['page-web-header']">
        <div :class="$style['header-title']">
          <p :class="$style['title']">新闻动态</p>
          <p :class="$style['desc']">News</p>
        </div>
        <img src="@/assets/img/news/news-header.png" :class="$style['header-img']"/>
      </div>
    </div>
    <div :class="$style['news-list']">
      <div :class="$style['list-item']" @click="handleDetail(item)" v-for="item in list" :key="item.id">
        <ArticleImage
          :class="$style['item-img']"
          :src="item.article_cover"
          :info="item.article_cover_point"
          :width="244"
          :height="137"
        />
        <div :class="$style['item-title']">
          <div :class="$style['item-header']">{{item.article_title}}</div>
          <div :class="$style['item-sub-header']">{{item.article_summary}}</div>
          <div :class="$style['item-anthor']">
            <span :class="$style['author']" v-if="item.author">作者：
              <span :class="$style['name']" v-for="it in item.author" :key="it.uid">{{it.nickname}}</span>
            </span>
            <span :class="$style['author']" v-if="item.translator">译者：
              <span :class="$style['name']" v-for="it in item.translator" :key="it.uid">{{it.nickname}}</span>
            </span>
            <span :class="$style['author']" v-if="item.planner">策划：
              <span :class="$style['name']" v-for="it in item.planner" :key="it.uid">{{it.nickname}}</span>
            </span>
          </div>
          <p :class="$style['time']">{{item.time}}</p>
        </div>
      </div>
    </div>
    <div :class="$style['btn-footer']">
      <p :class="$style['btn-action']" @click.stop="loadingMore" v-if="hasMore">加载更多新闻</p>
      <p :class="$style['btn-desc']" v-else>到底了</p>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import NewsService from '@/service/news.service.js'
import ArticleImage from './ArticleImage.vue'
export default {
  name: '',
  components: {
    ArticleImage
  },
  props: {
  },
  data () {
    return {
      page: 1,
      size: 10,
      list: [],
      hasMore: false
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this.getCount()
  },
  watch: {
  },
  methods: {
        // 获取文章置顶数量
    getCount () {
      const postData = {
        offset: this.page - 1,
        size: this.size
      }
      NewsService.getGeekbangList(postData)
      .then(data => {
        this.list = this.list.concat(data.list)
        this.hasMore = data.hasMore
        console.log(data)
      })
      .catch(() => {})
    },
    loadingMore () {
      this.page++
      this.getCount()
    },
    handleDetail (item) {
      sensors.track('click_general', {
        page_name: '官网新闻页面',
        button_name: item.article_title
      })

      if (item.type === 1) {
        const link = item.sub_type === 4 ? `${config.infoq}/news/${item.uuid}` : `${config.infoq}/article/${item.uuid}`
        window.open(link)
      }
    }
  }
}
</script>
<style lang='scss' module>
.news-page-web {
  padding-bottom: 60px;
  & .header {
    background: linear-gradient(89deg, #FFEBCD 0%, #FFF7EA 57%, #FFEBCD 100%);
  }
  & .page-web-header {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;
    height: 300px;
    margin: 0 auto;
    & .header-title {
      & .title {
        font-size: 42px;
        font-weight: 500;
        color: #333333;
        letter-spacing: 2px;
      }
      & .desc {
        font-size: 24px;
        font-weight: 600;
        color: #333333;
        letter-spacing: 2px;
      }

    }
     & .header-img {
      width: 323px; height: 238px;

     }
  }
  & .news-list {
    width: 1200px;
    margin: 60px auto;
    & .list-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 30px;
      cursor: pointer;

      & .item-img {
        width: 244px;
        height: 137px;
        margin-right: 30px;
        border-radius: 4px;
      }
      & .item-title {
        & .item-header {
          width: 846px;
          height: 30px;
          font-size: 19px;
          font-weight: 500;
          color: #303030;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        & .item-sub-header {
          display: -webkit-box;
          -webkit-box-orient: vertical;  //上下垂直
          -webkit-line-clamp: 2;  //自定义行数
          width: 100%;
          margin-top: 8px;
          width: 846px;
          font-size: 14px;
          font-weight: 400;
          color: #828A92;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        & .item-anthor {
          margin-top: 30px;
          font-size: 12px;
          font-weight: 400;
          color: #828A92;

          & .author {
            position: relative;
            margin-right: 24px;
            & .name {
              color: #303030;
            }
            &::after {
              position: absolute; top: 3px; right: -12px;
              content: '';
              width: 1px;
              height: 9px;
              background: #ADADAD;
            }
            &:last-child::after {
              display: none;
            }
          }
        }
        & .time {
          margin-top: 6px;
          font-size: 12px;
          font-weight: 400;
          color: #828A92;
        }
      }
    }
  }
  & .btn-footer {
    margin-top: 20px;
    text-align: center;
    & .btn-action {
      width: 260px; height: 44px;
      line-height: 44px;
      background: linear-gradient(315deg, #FFD492 0%, #FA8919 100%);
      border-radius: 25px;
      margin: 0 auto;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;

      &:hover {
        background: linear-gradient(315deg, #FFBA4E 0%, #FF7F00 100%);
      }
    }
    & .btn-desc {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 500;
      color: #888888;
    }
  }

}
</style>
